<!--<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">-->

<nav class="toolbar navbar navbar-light">
    <div class="form-inline">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>

        <button *ngIf="!visibilitySpinner" [disabled]="!habilitarEnviar" type="button" class="btn btn-outline-success" (click)="enviarSolicitud()"><i class="fa fa-envelope-o"></i> Enviar</button>
        <button *ngIf="visibilitySpinner" [disabled]="true" type="button" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Enviando
        </button>

    </div>
</nav>

<div class="animated fadeIn container-fluid">
    <div>
        <h5 *ngIf="refAtestFito !== null" style="display:inline">Referencia de Solicitud: {{refAtestFito}}</h5>
        <h5 *ngIf="refAtestFito !== null" style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <!--<img class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudAtest}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <label class="codigo2-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitud}}">{{codigoTipoSolicitud}}</label>-->
                <img class="estado-icono-big" container="body" src="{{IdTipoSolicitudAtestFito | IconoTipoSolicitudAtest}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <img class="estado-icono-big" container="body" src="{{solicitudAtestFito.IdEstado | IconoEstadoSolicitudAtest}}" ngbTooltip="{{tituloEstadoSolicitud}}" />

            </span>
        </h5>
        <h5 *ngIf="refAtestFito === null" style="display:inline">Solicitud </h5>
        <h5 *ngIf="refAtestFito === null" style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <img class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudAtest}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <label class="codigo2-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitud}}">{{codigoTipoSolicitud}}</label>
                <img class="estado-icono-big" container="body" src="{{solicitudAtestFito.IdEstado | IconoEstadoSolicitudAtest}}" ngbTooltip="{{tituloEstadoSolicitud}}" />

            </span>
        </h5>
    </div>

    <div *ngIf="fechaSolicitud !== null">
        <h5>Fecha de Envío: {{fechaSolicitud}}</h5>
    </div>

    <!--ICONO CHECK LISTA PARA ENVIO-->
    <div *ngIf="visibilityCheckEnvio" style="margin-top: 10px;">
        <h5 style="display:inline">
            <span>
                <img class="check-envio" src="{{ true | IconoCheckEnvio}}" />
            </span>
        </h5>
        <h5 style="display:inline"> La solicitud está lista para ser enviada</h5>
    </div>

    <div class="row">
        <div class="col-md-12">
            <!--Validaciones propias de la solicitud-->
            <table *ngIf="validacionCollection !== null && validacionCollection?.length > 0 && !visibilityCheckEnvio" class="table table-responsive table-sm">
                <tbody>
                    <tr *ngFor="let item of validacionCollection">
                        <td class="empty-grid">{{item}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<!--</form>-->
